import SearchBarSearchInput from '@components/ui/search/SearchBarInput/SearchBarSearchInput/SearchBarSearchInput';
import CustomIcon from '@components/utils/CustomIcon';
import { PlaneLanding, PlaneTakeOff, Change } from '@assets/icons';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import {
  SearchBarAirportSearchProps,
  SearchBarInputError,
} from '@components/views/flight/types';
import { useDebounceValue } from '@hooks/hooks';

import { IconContainer, SpaceWrapper, IconCircle } from '../FlightSearchStyle';
import {
  AirportsContainer,
  AirportWrapper,
  ArrivalAirportIconWrapper,
} from './SearchBarAirportSearchStyle';
import AirportSearchResultList from './AirportSearchResultList';

export interface AirportSearchProps extends SearchBarAirportSearchProps {
  departureAirportError: SearchBarInputError | boolean;
  arrivalAirportError: SearchBarInputError | boolean;
  className?: string;
  swapAirports: () => void;
}

export default function AirportSearch({
  departureAirportError,
  arrivalAirportError,
  departureAirportSearchText,
  onDepartureAirportTextChange,
  onDepartureAirportSelect,
  arrivalAirportSearchText,
  onArrivalAirportTextChange,
  onArrivalAirportSelect,
  className,
  swapAirports,
}: AirportSearchProps) {
  const debouncedDepartureSearchText = useDebounceValue(
    departureAirportSearchText
  );
  const debouncedArrivalSearchText = useDebounceValue(arrivalAirportSearchText);

  return (
    <AirportsContainer className={className}>
      <LocationAnimationErrorBox hasError={!!departureAirportError}>
        <AirportWrapper>
          <SearchBarSearchInput
            label='Nereden Gideceksiniz?'
            inputProps={{
              value: departureAirportSearchText,
              placeholder: 'Havalimanı veya Şehir',
              onChange: (e) => onDepartureAirportTextChange(e.target.value),
            }}
            leftIcon={() => (
              <CustomIcon
                fontSize={28}
                paletteColor='primaryBrand'
                icon={PlaneTakeOff}
              />
            )}
            SearchResultListComponent={({ onChange }) => (
              <AirportSearchResultList
                searchText={debouncedDepartureSearchText}
                onSelect={(item) => {
                  onChange(item.airportName);
                  onDepartureAirportSelect(item);
                }}
              />
            )}
          />
        </AirportWrapper>
      </LocationAnimationErrorBox>
      <SpaceWrapper>
        <IconContainer>
          <IconCircle
            onClick={() => {
              swapAirports();
            }}
          >
            <CustomIcon fontSize={20} icon={Change} />
          </IconCircle>
        </IconContainer>
      </SpaceWrapper>
      <LocationAnimationErrorBox hasError={!!arrivalAirportError}>
        <AirportWrapper>
          <SearchBarSearchInput
            label='Nereye Gideceksiniz?'
            inputProps={{
              value: arrivalAirportSearchText,
              placeholder: 'Havalimanı veya Şehir',
              onChange: (e) => onArrivalAirportTextChange(e.target.value),
            }}
            leftIcon={() => (
              <ArrivalAirportIconWrapper>
                <CustomIcon
                  fontSize={28}
                  paletteColor='primaryBrand'
                  icon={PlaneLanding}
                />
              </ArrivalAirportIconWrapper>
            )}
            popoverProps={{
              align: 'end',
            }}
            SearchResultListComponent={({ onChange }) => (
              <AirportSearchResultList
                searchText={debouncedArrivalSearchText}
                onSelect={(item) => {
                  onChange(item.airportName);
                  onArrivalAirportSelect(item);
                }}
              />
            )}
          />
        </AirportWrapper>
      </LocationAnimationErrorBox>
    </AirportsContainer>
  );
}
